import React from 'react';
import { motion } from 'framer-motion';
import { AngerMonster, HappinessMonster, CalmMonster } from './Monsters';
export const HeroSection = () => {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center overflow-hidden bg-cream pt-20 pb-16 px-6" data-id="element-94">
      {/* Background decorative elements */}
      <div className="absolute top-10 left-10 opacity-20 w-32 h-32 rounded-full bg-happiness blur-3xl" data-id="element-95"></div>
      <div className="absolute bottom-10 right-10 opacity-20 w-40 h-40 rounded-full bg-anger blur-3xl" data-id="element-96"></div>

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-97">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-start space-y-6" data-id="element-98">
          <div className="inline-block px-4 py-1.5 rounded-full bg-white/60 border border-dark/10 backdrop-blur-sm shadow-sm" data-id="element-99">
            <span className="font-body font-bold text-sm text-anger tracking-wide uppercase" data-id="element-100">
              Edición Especial para Familias Bilingües en USA
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-dark leading-tight" data-id="element-101">
            Bilingual Emotion <br data-id="element-102" />
            <span className="text-anger" data-id="element-103">Monsters</span>
          </h1>

          <h2 className="font-display text-2xl md:text-3xl text-dark/70 font-medium" data-id="element-104">
            Los Monstruos de las Emociones
          </h2>

          <p className="font-body text-lg md:text-xl text-dark/80 max-w-lg leading-relaxed" data-id="element-105">
            Guía de Coloreo y Gestión de Berrinches para Niños Valientes. A
            coloring guide and tantrum management tool for brave kids.
          </p>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="mt-4 px-8 py-4 bg-anger text-white font-display font-bold text-xl rounded-2xl shadow-glow-anger hover:bg-red-500 transition-colors cursor-pointer" data-id="element-106">
            Get Your Copy / Obtén tu Copia
          </motion.button>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative flex justify-center items-center" data-id="element-107">
          {/* Floating Monsters around the book */}
          <motion.div className="absolute -top-10 -left-10 w-24 h-24 z-20 hidden md:block" animate={{
          y: [0, -15, 0],
          rotate: [-5, 5, -5]
        }} transition={{
          repeat: Infinity,
          duration: 4
        }} data-id="element-108">
            <HappinessMonster data-id="element-109" />
          </motion.div>

          <motion.div className="absolute -bottom-5 -right-5 w-20 h-20 z-20 hidden md:block" animate={{
          y: [0, 10, 0],
          rotate: [5, -5, 5]
        }} transition={{
          repeat: Infinity,
          duration: 3.5
        }} data-id="element-110">
            <CalmMonster data-id="element-111" />
          </motion.div>

          <motion.div className="absolute top-1/2 -right-12 w-16 h-16 z-0 hidden md:block" animate={{
          x: [0, 10, 0]
        }} transition={{
          repeat: Infinity,
          duration: 5
        }} data-id="element-112">
            <AngerMonster data-id="element-113" />
          </motion.div>

          <motion.img src="https://cdn.magicpatterns.com/uploads/7K2wwjnW9CLw7orbFpsR7k/libro_para_colorear.png" alt="Bilingual Emotion Monsters Coloring Book" className="w-full max-w-md rounded-2xl shadow-2xl z-10 relative" animate={{
          y: [-5, 5, -5]
        }} transition={{
          repeat: Infinity,
          duration: 6,
          ease: 'easeInOut'
        }} style={{
          transform: 'rotate(-2deg)'
        }} data-id="element-114" />
        </motion.div>
      </div>
    </section>;
};